import { LayoutNoSidebar } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  LayoutNoSidebar,
  React
};